<template>
  <form id="changepassword" method="post" @submit.prevent="validateAndSubmit">
    <div class="formsectioncompound">
      <div class="jq_gridcontentarea">
        <input-field
          id="password"
          :$v="$v.password"
          :value="password"
          :required="true"
          :tooltip="{content:'Wachtwoorden moeten minimaal 8 en maximaal 32 tekens zijn bestaande uit minimaal 1 hoofdletter, 1 kleine letter en 1 cijfer.'}"
          type="password"
          label="Wachtwoord *"
          validation-message-translation-name-space="resetPasswordForm"
          name="password"
          @input="(v) => setPassword(v)"
        />
      </div>
      <div class="jq_gridcontentarea">
        <input-field
          id="confirm_password"
          :$v="$v.confirmPassword"
          :value="confirmPassword"
          :required="true"
          type="password"
          label="Bevestig wachtwoord *"
          validation-message-translation-name-space="resetPasswordForm"
          name="confirm_password"
          @input="(v) => setConfirmPassword(v)"
        />
      </div>
      <div class="jq_gridcontentarea">
        <div class="wm-field large-12 columns">
          <button type="submit">
            {{ $t('resetPasswordForm.send-new-password') }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import InputField from './fields/InputField'
import { required, sameAs } from 'vuelidate/lib/validators'
import ShowAlertErrorHandler from '../../mixins/show-alert-error-handler'
import { password } from '../../validators'

export default {
  name: 'ResetPasswordForm',
  components: {
    InputField
  },
  mixins: [ShowAlertErrorHandler],
  data: () => {
    return {
      password: '',
      confirmPassword: ''
    }
  },
  validations: {
    password: {
      required,
      password
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  methods: {
    setPassword (value) {
      this.password = value
    },

    setConfirmPassword (value) {
      this.confirmPassword = value
    },

    validateAndSubmit () {
      if (!this.validate()) {
        return false
      }
      this.submit()
    },
    validate () {
      this.$v.$touch()
      return !this.$v.$invalid
    },

    async submit () {
      try {
        await this.$store.dispatch('user/resetPassword', {password: this.password})
        this.showAlert(this.$t('resetPasswordForm.successAlertMessage'))
        this.$router.push({name: 'home'})
      } catch (error) {
        this.showAlertForErrorAndRedirectToRoute(
          error,
          {404: this.$t('resetPasswordForm.errorTokenInvalid')},
          {404: {name: 'forgot-password'}}
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/ResetPasswordForm.vue